import FollowTag from './FollowTag'

export default FollowTag
